import { useUserContext } from "../components/UserContextProvider";
import { useApi, isOk } from "../api";
import { useToast } from "../components/MessageBox";
import { useTranslation } from "../hooks/useTranslation";
import Text from "../components/Text";

export default function AdminSettings() {
    const { user, setUser } = useUserContext();
    const api = useApi();
    const toast = useToast();
    const { t } = useTranslation();

    // A per-user setting, not a cookie: this never touches Permissions, so unlike the old
    // view-as-member toggle it cannot affect access to the admin center itself, and it takes
    // effect the moment the member app next loads /api/User (no relogin, no reload here).
    const toggleMainAppVisibility = async () => {
        const next = !user().showAdminUiInMemberApp;
        const res = await api.access.setMainAppAdminVisibility({ enabled: next });
        if (isOk(res.data)) {
            setUser(prev => ({ ...prev, showAdminUiInMemberApp: next }));
            toast?.info(t(next ? 'ADMIN_MAIN_APP_VISIBILITY_ENABLED' : 'ADMIN_MAIN_APP_VISIBILITY_DISABLED'));
        } else {
            toast?.error(t('ADMIN_MAIN_APP_VISIBILITY_SAVE_FAILED'));
        }
    };

    return (
        <div class="dashboard-page">
            <h1><Text val="ADMIN_SETTINGS_TITLE" /></h1>

            <div class="page-card">
                <div class="page-section">
                    <h2><i class="fa-solid fa-eye" style={{ "margin-right": "8px", opacity: "0.6" }}></i><Text val="ADMIN_SETTINGS_VISIBILITY_SECTION" /></h2>

                    <label class="permission-item" style={{ cursor: "pointer", "max-width": "fit-content" }} onClick={() => void toggleMainAppVisibility()}>
                        <input type="checkbox" checked={user().showAdminUiInMemberApp === true} />
                        <div class="v" style={{ gap: "2px" }}>
                            <span><Text val="ADMIN_MAIN_APP_VISIBILITY_LABEL" /></span>
                            <span class="gray" style={{ "font-size": "var(--font-size-xs)", "font-weight": "normal" }}>
                                <Text val="ADMIN_MAIN_APP_VISIBILITY_DESC" />
                            </span>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    );
}
